import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import { getSeekerAnalyticsQue } from "../../../../API/api";
import { Spin } from "antd";
import styles from "./seeker.module.css";
import { Space } from "antd";
import ServerTableAnt from "../../../AntDesignTable/ServerTableAnt";
import CountUp from "react-countup";
import VizHeader from "../../../VizHeader/VizHeader";
import { SearchOutlined } from "@ant-design/icons";
import { DebounceInput } from "react-debounce-input";
import { convertMinutesToDaysHoursMinutes } from "../../../../utils";
import TitleValue from "./TitleValue";
import { bindActionCreators } from "redux";
import { Actions } from "../../../../Action";
import TooltipComp from "../../../../NewComponent/ToolTip/TooltipComp";
import { Rate } from 'antd';

const textStyles = {
  fontSize: "16px",
  color: "#2A364A",
  fontWeight: "500",
  // lineHeight: "24px",

  // wordBreak: "break-word",
  marginRight: "5px"

};
const textStylesHeader = {
  fontSize: "18px",
  color: "#2A364A",
  fontWeight: "500",
  // lineHeight: "24px",

  // wordBreak: "break-word",
  marginRight: "5px"

};
const containerStyle = {
  width: "100%",
  // margin: "auto",
  // marginTop: "1%",
  marginBottom: "1%",
  border: "1px solid #E0E2E6",
  background: "#FFFFFF",
  borderRadius: "12px",
  boxShadow: "0px 4px 16px 0px #1018280F",
  padding: "28px",

};

const columnsData = [
  {
    title: TitleValue("Geo"),
    dataIndex: "Geo",
    align: "left",
    width: 160,
    style: { fontSize: "18px", fontWeight: "400" },
    render: (_, raw) => (
      <>
        <span style={{
          fontSize: "13px",
          color: "#2A364A",
          fontWeight: "500"
        }}>{raw.Geo}</span>
      </>
    ),
  },
  {
    title: TitleValue("Seeker"),
    dataIndex: "Seeker",
    align: "left",
    width: 250,
    render: (_, raw) => (
      <>
        <span style={{
          fontSize: "13px",
          color: "#2A364A",
          fontWeight: "500",
        }}>
          {raw.Seeker}
        </span>
      </>
    ),
  },
  {
    title: TitleValue("Question Submitted"),
    dataIndex: "QuestionSubmitted",
    align: "center",
    width: 150,
    sorter: true,
    defaultSortOrder: "descend",
    render: (_, raw) => (
      <>
        <span style={{
          fontSize: "13px",
          color: "#2A364A",
          fontWeight: "500",
        }}>
          <CountUp
            end={raw.QuestionSubmitted}
            duration={3.75}
            style={{
              fontSize: "13px",
              color: "#2A364A",
              fontWeight: "500",
            }}
          />
          {/* {raw.QuestionSubmitted} */}
        </span>
      </>
    ),
  },

  {
    title: TitleValue("Answered"),
    dataIndex: "Answered",
    align: "center",
    width: 150,
    sorter: true,
    render: (_, raw) => (
      <>
        <span
          style={{
            fontSize: "13px",
            color: "#2A364A",
            fontWeight: "500",
            display: "flex",
            width: "50%",
            justifyContent: "flex-end",
            textAlign: "right",
          }}
        >
          <CountUp
            end={raw?.Answered}
            duration={3.75}
            style={{
              fontSize: "13px",
              color: "#2A364A",
              fontWeight: "500",
            }}
          />
          {/* {raw.Answered} */}
        </span>
      </>
    ),
  },
  {
    title: TitleValue("Rated"),
    dataIndex: "Rated",
    align: "center",
    width: 150,
    sorter: true,
    render: (_, raw) => (
      <>
        <span
          style={{
            fontSize: "13px",
            color: "#2A364A",
            fontWeight: "500",
            display: "flex",
            width: "50%",
            justifyContent: "flex-end",
            textAlign: "right",
          }}
        >
          <CountUp
            end={raw?.Rated}
            duration={3.75}
            style={{
              fontSize: "13px",
              color: "#2A364A",
              fontWeight: "500",
            }}
          />
          {/* {raw.Rated} */}
        </span>
      </>
    ),
  },
  {
    title: TitleValue("Avg Of Rating"),
    dataIndex: "AvgOfRating",
    align: "center",
    width: 150,
    render: (_, raw) => {
      const rating = raw.AvgOfRating; // This should already be out of 5
      return (
        <div style={{
          fontSize: "13px",
          color: "#2A364A",
          fontWeight: "500",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          justifyContent: "center"
        }}>
          <Rate allowHalf disabled value={rating} style={{ fontSize: 17 }} />
        </div>
      );
    },
  },
  {
    title: TitleValue("Avg Response Time"),
    dataIndex: "AvgResponseTime",
    align: "center",
    width: 150,
    render: (_, raw) => (
      <>
        <span
          style={{
            fontSize: "13px",
            color: "#2A364A",
            fontWeight: "500",
            display: "flex",
            width: "78%",
            justifyContent: "flex-end",
            textAlign: "right",
          }}
        >
          {raw.AvgResponseTime}
        </span>
      </>
    ),
  },
];

function SearchBar({ searchValue, handleSearch, setSearchValue }) {
  return (
    <>
      {" "}
      <Space.Compact>
        <span className={styles.search}>
          <SearchOutlined />
          <DebounceInput
            debounceTimeout={800}
            placeholder="Search"
            autoComplete="off"
            outline={true}
            onChange={handleSearch}
            value={searchValue}
            allowClear
            style={{ border: "none", paddingLeft: "10px" }}
          />

          {searchValue.length > 3 && (
            <>
              <span className={styles.cross} onClick={() => setSearchValue("")}>
                <svg
                  fill-rule="evenodd"
                  viewBox="64 64 896 896"
                  focusable="false"
                  data-icon="close-circle"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"></path>
                </svg>
              </span>
            </>
          )}
        </span>
      </Space.Compact>
    </>
  );
}



export default function SeekerSubmittedStatistics({ userType }) {
  // const [userType, setUserType] = useState("");
  const [seekerSubmitted, setSeekerSubmitted] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [filterValue, setFilterValue] = useState("questionSubmittedDesc");
  const selectUser = useSelector((state) => state.seekerType);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const dispatch = useDispatch();
  const cmState=useSelector((state)=>state.cmRoot)
  const { seekerSubmittedAction } = bindActionCreators(Actions, dispatch);
  // seekerSubmittedAction
  const { geoLevelId, geoLevelValue, domainId, length, check } = useSelector(
    (state) => {
      return {
        geoLevelId: state.cmRoot.selecetdRoutingValue,
        geoLevelValue: state.cmRoot?.selectedGeoLevel?.name,
        domainId: state.cmRoot?.selectedDomainIds,
        length: state.cmRoot?.selectedDomainsObj?.length,
        check: state.cmRoot.selecetdRoutingValue,
      };
    }
  );

  React.useEffect(() => {
    if (check !== "") {
      setLoading(true);
      getSeekerAnalyticsQue(
        geoLevelId,
        geoLevelValue,
        selectUser.userType.value !== null ? selectUser.userType.value : "",
        domainId,
        filterValue,
        pageNo,
        searchValue,
        pageSize
      ).then((res) => {
        if (res === undefined) return;
        setCount(res?.data?.count);
        setLoading(false);
        setSeekerSubmitted(res?.data?.data);
        seekerSubmittedAction(res?.data?.data)
      });
    }
  }, [
    geoLevelId,
    geoLevelValue,
    selectUser.userType,
    domainId,
    filterValue,
    searchValue,
    length,
    pageNo,
    pageSize,
    check,cmState
  ]);

  const rows =
    seekerSubmitted &&
    seekerSubmitted?.map((item, index) => ({
      id: index, // Assigning a unique ID to each row
      Geo: item.location,
      Seeker: `${item.firstName}\u00A0${item.lastName}`,
      QuestionSubmitted: item.submittedQuestion,
      // .toString()
      // .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      Answered: item.answers,
      // .toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      Rated: `${item.rated}`,
      AvgOfRating:
        item.avgRating !== null || undefined ? `${item.avgRating}` : "-",
      AvgResponseTime: convertMinutesToDaysHoursMinutes(item.avgResponse),
    }));

  const handleSearch = (event) => {
    setSearchValue(event.target.value);
  };
  const valueData =
    Array.isArray(seekerSubmitted) &&
    seekerSubmitted.length > 0 &&
    seekerSubmitted[0]?.location;
  // console.log("valueData",valueData)
  return (
    <Spin
        spinning={loading}
        style={{
          marginTop: "30px",
          width: "100%",
          padding: "30px",
          // paddingTop: "15px",
          // paddingBottom: "0px",
        }}
      >
        <div
        // style={{
        //   padding: "30px",
        //   paddingTop: "15px",
        //   paddingBottom: "0px",
        // }}
        >
          <div style={{ display: "flex", justifyContent: "center" }}>
            {" "}
            <span style={textStylesHeader}>
              Seeker Submitted Statistics
            </span>

          </div>
          <Box className={styles.header}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                // paddingBottom: "15px",
                width: "100%",
              }}
            >
              <SearchBar
                searchValue={searchValue}
                handleSearch={handleSearch}
                setSearchValue={setSearchValue}
              />
              {/* <span style={{ display: "flex", gap: "5px" }}>
                <span style={textStyles}>
                  Location:
                </span>
                <span style={textStyles}>
                  {valueData}
                </span>
              </span> */}
            </Box>
          </Box>

          <Box sx={{ mt: 2 }}>
            <ServerTableAnt
              data={rows}
              columns={columnsData}
              count={count}
              setFilterValue={setFilterValue}
              setPageNo={setPageNo}
              setPageSize={setPageSize}
            />
          </Box>
        </div>
      </Spin>
  );
}
